module.exports = __webpack_public_path__ + "img/payment_cart.a29a3e6c.png";